import React, { useContext } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { IApplicationContext } from 'interfaces/i-application-context-props'
import { ApplicationDispatchContext } from 'contexts/ApplicationContext'
import { MSP_ACTIONS, MspDispatchContext } from 'components/multistep/Multistep'
import { DocumentTypes } from 'constants/enums/documentTypes'
import { UploadDocumentsDropZoneItems } from 'components/application-blocks/common-blocks/UploadDocuments/UploadDocumentsDropZoneItems'
import { DocumentTypesNorway } from 'constants/values/uploadDocumentsTypes'

import './UploadDocuments.scss'

export const UploadDocumentsNo = () => {
	const { t } = useTranslation()
	const { loanApplication }: IApplicationContext = useContext(
		ApplicationDispatchContext,
	)
	const { msp, dispatchMsp } = useContext(MspDispatchContext)

	const documentsNeedUpload = [DocumentTypes.TaxReturn, DocumentTypes.Payroll]

	const back = () => {
		dispatchMsp({
			type: MSP_ACTIONS.SET_INDEX,
			payload: {
				index: msp.index - 1,
			},
		})
	}

	return (
		<div className="upload-documents norway">
			<div className="upload-documents-description-top">
				<Trans t={t} i18nKey="UploadDocumentText">
					Here you can manually upload your Tax Return and Payslip if
					you chose not to sign the Consent-based Loan Application.
					<br />
					<br />
					If the purpose of the loan is to refinance existing debt, we
					also ask that you upload payment information on this (KID
					and account) by adding a screenshot/image of the latest
					invoice for loans and credits to be refinanced.
				</Trans>
			</div>
			<UploadDocumentsDropZoneItems
				documentTypes={DocumentTypesNorway}
				applicationData={loanApplication}
				documentsNeedUpload={documentsNeedUpload}
			/>
			<div className="upload-documents-back-button-section">
				<button
					className="btn btn-secondary dark-gray"
					onClick={() => back()}>
					{t('Back')}
				</button>
			</div>
		</div>
	)
}
